
import { Component, Vue } from "vue-property-decorator";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";

import { mapState } from "vuex";
import ListRequest, { Filter, Ordering, OrderType } from "@/models/ListRequest";
import IngredientSearchFailure from "@/models/Ingredient/IngredientSearchFailure";
import IngredientsRepository from "@/utils/API/IngredientsRepository";
import { dateTimeDisplayFormat } from "@/utils/Defaults";

import vTable from "@/components/vTable.vue";

@Component({
  components: {
    vTable
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      customersState: (state: any) => state.CustomersModule
    })
  }
})
class SearchReports extends Vue {
  localizationState: any;

  // vTable props
  loading = false;

  ingredientSearchFailures: IngredientSearchFailure[] = [];

  totalCount: number = 0;
  pageSize: number = 20;
  count: number = 0;
  page: number = 1;
  filters: Filter[] = [];
  ordering: Ordering = {
    field: "CreatedOn",
    orderType: OrderType.Desc
  };

  // models
  ingredientSearchFailure: IngredientSearchFailure = {
    id: 0,
    searchingUserName: "",
    searchTerm: "",
    searchingUserEmail: "",
    searchResultsCount: 0,
    restaurantName: "",
    createdOn: ""
  };

  changePage(args: any) {
    let page = args[0];
    let filters = args[2];
    let orderings = args[3];

    this.page = page;
    this.ordering =
      orderings.length > 0
        ? orderings[0]
        : { field: "", orderType: OrderType.Asc };
    this.filters = filters;

    this.requestIngredientSearchFailures();
  }

  order(filters: Filter[], orders: Ordering) {
    this.ordering = orders;
    this.filters = filters;

    this.requestIngredientSearchFailures();
  }

  search(filters: Filter[], ordering: Ordering) {
    this.page = 1;
    this.ordering = ordering;
    this.filters = filters;

    this.requestIngredientSearchFailures();
  }

  // Request for ListIngredientCost
  requestIngredientSearchFailures() {
    let orderings = [this.ordering];
    let filters = this.filters;

    let reqData = new ListRequest({
      page: this.page,
      pageSize: this.pageSize,
      filters: filters,
      orders: orderings
    });

    this.loading = true;

    IngredientsRepository.listIngredientSearchFailures(reqData)
      .then((response) => {
        this.count = response.data.count;
        this.totalCount = response.data.totalCount;
        this.ingredientSearchFailures = response.data.result;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  get ingredientSearchFailuresForGrid() {
    return this.ingredientSearchFailures.map((x) => {
      return {
        meta: {
          id: x.id
        },
        e1: x.restaurantName,
        e2: x.searchingUserName,
        e3: x.searchingUserEmail,
        e4: x.searchTerm.length > 0 ? x.searchTerm : "N/A",
        e5: x.searchResultsCount,
        e6: this.$moment(x.createdOn).format(dateTimeDisplayFormat)
      };
    });
  }

  // Table headers
  get tableHeaders() {
    return [
      {
        name: this.translations.get("search-report-restaurant-name"),
        key: "RestaurantName",
        searchable: true,
        searchString: "",
        sortable: true
      },
      {
        name: this.translations.get("search-report-user-name"),
        key: "SearchingUserName",
        searchable: true,
        searchString: "",
        sortable: true
      },
      {
        name: this.translations.get("search-report-email"),
        key: "SearchingUserEmail",
        searchable: true,
        searchString: "",
        sortable: true
      },
      {
        name: this.translations.get("search-report-search-term"),
        key: "SearchTerm",
        searchable: true,
        searchString: "",
        sortable: true
      },
      {
        name: this.translations.get("search-report-resault-count"),
        key: "SearchResultsCount",
        searchable: false,
        searchString: "",
        sortable: false
      },
      {
        name: this.translations.get("search-report-date"),
        key: "CreatedOn",
        searchable: false,
        searchString: "",
        sortable: true
      }
    ];
  }

  mounted() {
    this.loading = true;
  }

  created() {
    this.$store.dispatch(TRANSLATIONS_FETCH, {
      category: "pages",
      collections: ["partners", "common", "search-reports"]
    });

    this.requestIngredientSearchFailures();
    document.title = "SearchReports | MenuSano";
  }

  get translations() {
    return this.localizationState.translations;
  }
}
export default SearchReports;
